import {
  namePatternMatch,
  formatCurrency,
  emailPatternMatch,
  formatString,
  onlinePaymentMethods,
  getAmountDue,
} from "../../../utilities/helpers";

import { isValidPhoneNumber } from "react-phone-number-input";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";

import { PhoneNumberInput } from "../../../components/PhoneNumberInput";
import { Error } from "../../../components/Error";
import CardForm from "../CardForm";
import { AsyncSelectControl } from "../../../components/AsyncSelectControl";
import { LoadingContainer } from "../../../components/LoadingContainer";
import { SavedCard } from "../../../components/SavedCard";
import SelectedTickets from "../SelectedTickets";
import { InfoCard } from "./InfoCard";

export default function AssignTo({
  selectedTickets,
  amountToPay,
  assignTo,
  onAssignToChange,
  isValidEmail,
  setIsValidEmail,
  isValidNumber,
  setIsValidNumber,
  buyerTypes,
  selectedBuyerType,
  setSelectedBuyerType,
  compLabels,
  selectedCompLabel,
  setSelectedCompLabel,
  clientSecret,
  initialClientSecret,
  setCard,
  setStripe,
  userType,
  setUserType,
  setInitialExistingUser,
  existingUser,
  setExistingUser,
  loadExistingUsers,
  setIsCardValid,
  savedCards,
  isLoadingCards,
  selectedCard,
  setSelectedCard,
  paymentMethod,
  openDelete,
  paymentSchedule,
  installmentMonths,
  paymentPlans,
  isReserving = false,
  pricingObject,
  showRemoveSeat,
  onRemoveSeat,
}) {
  const normalizedPaymentMethod = String(paymentMethod || "").toUpperCase();
  const isReservedPayment = normalizedPaymentMethod === "RESERVED";

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "email" || value === "" || e.target.validity.valid) {
      onAssignToChange(name, value);
    }
  };

  const handleValidEmail = (e) => {
    if (!emailPatternMatch(e.target.value)) {
      setIsValidEmail(false);
    } else {
      setIsValidEmail(true);
    }
  };

  const handleValidNumber = () => {
    // Since not required -> empty is valid
    if (!assignTo.phoneNumber) {
      setIsValidNumber(true);
      return;
    }

    setIsValidNumber(isValidPhoneNumber(assignTo.phoneNumber));
  };

  const handleExistingUser = (selected) => {
    if (selected) {
      if (existingUser) {
        // set initial state to previous existing user
        setInitialExistingUser(existingUser);
      } else {
        // if no previous existing user (first time), set to new existing user
        setInitialExistingUser(selected);
      }
      // set state to new existing user
      setExistingUser(selected);
    }
  };

  const getNameInitials = (user) => {
    if (user) {
      return `${user?.firstName?.charAt(0)}${user?.lastName?.charAt(0)}`;
    }
  };

  return (
    <Stack gap={4}>
      {paymentMethod === "COMP" && (
        <SelectedTickets
          selected={selectedTickets}
          showRemoveSeat={showRemoveSeat}
          onRemoveSeat={onRemoveSeat}
        />
      )}
      {paymentMethod &&
        paymentMethod === "COMP" &&
        compLabels &&
        compLabels.length > 0 && (
          <Form.Group controlId="comp-label">
            <Form.Label>Comp type</Form.Label>
            <Form.Select
              name="comp-label"
              onChange={(e) => setSelectedCompLabel(e.target.value)}
              value={selectedCompLabel || ""}
              required
              aria-labelledby="comp-label"
              autoFocus
            >
              <option disabled hidden value="">
                Select Comp type
              </option>
              {compLabels?.map((label, idx) => (
                <option key={idx} value={label?.id}>
                  {label?.attributes?.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

      {paymentMethod &&
        paymentMethod !== "COMP" &&
        buyerTypes &&
        buyerTypes.length > 0 && (
          <Form.Group controlId="buyer-label">
            <Form.Label>Buyer type</Form.Label>
            <Form.Select
              name="buyer-label"
              onChange={(e) => setSelectedBuyerType(e.target.value)}
              value={selectedBuyerType || ""}
              required
              aria-labelledby="buyer-label"
              autoFocus
            >
              <option disabled hidden value="">
                Select Buyer type
              </option>
              {buyerTypes?.map((label, idx) => (
                <option key={idx} value={label?.id}>
                  {label?.attributes?.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      {/* { !isReserving && (
                     <Row>
        <Col>
          <div>
            <h5 id="user-type" className="small small-bold">
              User Type
            </h5>
            <Form.Select
              name="user-type"
              onChange={(e) => setUserType(e.target.value)}
              value={userType}
              required
              aria-labelledby="user-type"
            >
              <option value="new-user">New User</option>
              <option value="existing-user">Existing User</option>
            </Form.Select>
          </div>
        </Col>
      </Row> 
        )} */}
      {userType === "new-user" ? (
        <>
          <Form.Group className="form-group" controlId="orgName">
            <Form.Label>Organization name (optional)</Form.Label>
            <Form.Control
              type="text"
              name="organizationName"
              placeholder="Enter your organization name"
              value={assignTo?.organizationName || ""}
              onChange={handleChange}
              autoComplete="none"
            />
          </Form.Group>
          <Row className="m-0">
            <Col className="ps-0">
              <Form.Group className="form-group" controlId="firstName">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  pattern={namePatternMatch}
                  placeholder="Enter your first name"
                  value={assignTo?.firstName || ""}
                  onChange={handleChange}
                  required
                  autoComplete="none"
                />
              </Form.Group>
            </Col>
            <Col className="pe-0">
              <Form.Group className="form-group" controlId="lastName">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  pattern={namePatternMatch}
                  placeholder="Enter your last name"
                  value={assignTo?.lastName || ""}
                  onChange={handleChange}
                  required
                  autoComplete="none"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="m-0">
            <Col className="ps-0">
              <Form.Group className="form-group" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={assignTo?.email || ""}
                  onChange={handleChange}
                  onBlur={handleValidEmail}
                  required
                  autoComplete="none"
                  className={`${!isValidEmail ? "error-border" : ""}`}
                />

                {!isValidEmail && <Error type="invalidEmail" />}
              </Form.Group>
            </Col>
            <Col className="pe-0">
              <Form.Group className="form-group" controlId="lastName">
                <Form.Label>Phone number</Form.Label>
                <PhoneNumberInput
                  phoneNumber={assignTo?.phoneNumber}
                  setPhoneNumber={(value) =>
                    onAssignToChange("phoneNumber", value)
                  }
                  isRequired={false}
                  onBlur={handleValidNumber}
                  hasError={!isValidNumber}
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <AsyncSelectControl
            placeholder="Search by name, phone number or email"
            loadUsers={loadExistingUsers}
            existingUser={existingUser}
            onChange={handleExistingUser}
            noOptionsMessage={() => "No users found"}
            defaultUser={{
              ...assignTo,
              custom: assignTo?.email,
              label: `${assignTo?.firstName} ${assignTo?.lastName}`,
            }}
          />
          {existingUser && (
            <Stack direction="horizontal" gap={3}>
              <div className={`user-profile user-profile--primary`}>
                <span>{getNameInitials(existingUser)}</span>
              </div>
              <Stack gap={1}>
                <span className="heading m-0">{existingUser?.label}</span>
                <span className="d-block small">{existingUser?.custom}</span>
              </Stack>
            </Stack>
          )}
        </>
      )}
      {/* credit-card */}
      {paymentMethod === "CARD" && (
        <>
          {existingUser ? (
            <>
              {isLoadingCards ? (
                <LoadingContainer />
              ) : (
                <Stack gap={3}>
                  <h1 className="normal normal-bold m-0">Saved cards</h1>
                  {savedCards && savedCards?.length > 0 ? (
                    <Stack gap={3} as="ul">
                      {savedCards?.map((card, idx) => (
                        <SavedCard
                          key={idx}
                          card={card}
                          user={existingUser}
                          selected={selectedCard}
                          setSelected={setSelectedCard}
                          selectable={true}
                          openDelete={openDelete}
                        />
                      ))}
                    </Stack>
                  ) : (
                    <Card body className="card--xs info-card card-with-border">
                      <Card.Text className="info-text info-text-md">
                        At this moment, there are no saved cards for this user.
                        Cards will be automatically stored here after completing
                        a successful transaction.
                      </Card.Text>
                    </Card>
                  )}
                  <div>
                    <h1 className="normal normal-bold mb-3">Use a new card</h1>
                    <CardForm
                      client_secret={clientSecret}
                      initialClientSecret={initialClientSecret}
                      selectedCard={selectedCard}
                      setSelectedCard={setSelectedCard}
                      setCard={setCard}
                      setStripe={setStripe}
                      setIsCardValid={setIsCardValid}
                    />
                  </div>
                </Stack>
              )}
            </>
          ) : (
            <>
              {(clientSecret || initialClientSecret) && (
                <Row className="m-0">
                  <h1 className="normal normal-bold mb-3">
                    Enter card details
                  </h1>
                  <CardForm
                    client_secret={clientSecret}
                    initialClientSecret={initialClientSecret}
                    setCard={setCard}
                    setStripe={setStripe}
                    setIsCardValid={setIsCardValid}
                  />
                </Row>
              )}
            </>
          )}
        </>
      )}
      {/* invoice */}
      {paymentMethod === "INVOICE" ? (
        <>
          {assignTo?.email && (
            <InfoCard
              paymentPlans={paymentPlans}
              installmentMonths={installmentMonths}
              total={amountToPay}
            >
              <span>
                A Stripe payment link will be sent to{" "}
                <span className="text-primary">{assignTo?.email}</span>
              </span>
            </InfoCard>
          )}
        </>
      ) : isReservedPayment ? null : (
        <InfoCard
          paymentPlans={paymentPlans}
          installmentMonths={installmentMonths}
          total={amountToPay}
        >
          <span>
            Amount to{" "}
            {onlinePaymentMethods.includes(paymentMethod)
              ? "charge on card"
              : `collect via ${formatString(paymentMethod)} from buyer`}
            {paymentSchedule === "payment-plan" && " now"}:{" "}
            <span className="normal normal-bold">
              {formatCurrency(
                paymentSchedule === "payment-plan"
                  ? paymentPlans[1]?.amount
                  : paymentMethod === "COMP"
                    ? 0
                    : amountToPay,
              )}
            </span>
          </span>
        </InfoCard>
      )}
    </Stack>
  );
}
